import { format } from 'date-fns'
import { FireRiskEnum } from '../enum/FireRisk.enum'

export class RecentFireRisk {
	constructor(
		readonly fmaPlus: number,
		readonly timestamp: Date,
		readonly id: string,
		readonly risk: FireRiskEnum,
		readonly monitoredAreaName: string,
	) {}

	get dateLabel(): string {
		return format(new Date(this.timestamp), "dd/MM/yyyy 'às' HH:mm:ss")
	}

	get riskLabel(): string {
		if (this.risk === FireRiskEnum.NONE) return 'NULO'
		else if (this.risk === FireRiskEnum.HIGHEST) return 'MUITO ALTO'
		else if (this.risk === FireRiskEnum.SMALL) return 'PEQUENO'
		else if (this.risk === FireRiskEnum.MEDIUM) return 'MÉDIO'
		else return 'ALTO'
	}
}
